import { NgModule } from '@angular/core';
import {TourMatMenuModule} from 'ngx-ui-tour-md-menu';
import { SettingsComponent } from './components/settings.component';
import { AdminModule } from '@src/app/layout/admin/admin.module';
import { SettingsRoutingModule } from './settings-routing.module';
import { OrganisationSettingsComponent } from './components/organisation-settings/organisation-settings.component';
import { RolesComponent } from './components/roles/roles.component';
import { RoleEditComponent } from './components/role-edit/role-edit.component';
import { CreditLogsComponent } from './components/credit-logs/credit-logs.component';
import { SystemSettingsComponent } from './components/system-settings/system-settings.component';
import { FormCategoriesComponent } from './components/form-categories/form-categories.component';
import { FormCategoryFormComponent } from './components/form-categories/form-category-form.component';
import { MasterDataComponent } from './components/master-data/master-data.component';
import { DoorTypesComponent } from './components/door-types/door-types.component';
import { DoorTypeFormDialogComponent } from './components/door-types/door-type-form-dialog.component';
import { OptionGroupsComponent } from './components/option-groups/option-groups.component';
import { OptionGroupFormComponent } from './components/option-groups/option-group-form.component';
import { MatListModule } from '@angular/material/list';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {PreWorkSettingsComponent} from './components/pre-work-settings/pre-work-settings.component';

@NgModule({
    imports: [
        AdminModule,
        SettingsRoutingModule,
		TourMatMenuModule,
        MatListModule,
        DragDropModule,
        DoorTypeFormDialogComponent,
    ],
	declarations: [
		SettingsComponent,
		OrganisationSettingsComponent,
		RolesComponent,
		RoleEditComponent,
		CreditLogsComponent,
        SystemSettingsComponent,
        FormCategoriesComponent,
        FormCategoryFormComponent,
        MasterDataComponent,
        DoorTypesComponent,
        OptionGroupsComponent,
        OptionGroupFormComponent,
        PreWorkSettingsComponent,
	],
	exports: [
		SettingsComponent,
		OrganisationSettingsComponent,
		RolesComponent,
		RoleEditComponent,
		CreditLogsComponent,
		SystemSettingsComponent,
		FormCategoriesComponent,
		MasterDataComponent,
		PreWorkSettingsComponent,
	]
})
export class SettingsModule { }
